import script from "./ProjectsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsSection.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsSection.vue?vue&type=style&index=0&id=66b4eafe&scoped=true&lang=scss"

import exportComponent from "/Users/kadir.aslan/Projects/Repositories/Personal/kadiraslan-de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66b4eafe"]])

export default __exports__